module.exports = __webpack_public_path__ + "img/custom-reports.61b733ba.png";